import ApiConnector from "@/repository/connector";

class Layouts {
  get = async (params) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.get(`/api/layouts/`, { params });
    result.value = response.data;
    result.error = response.detail
    return result;
  };
}

export default new Layouts()